"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.receiveGetPipelines = exports.getPipelines = exports.GetPipelinesActionTypes = exports.PipelineActionTypes = void 0;

var _fluxActions = require("flux-actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-lib/utils/namespacedKeyMirror"));

var _actions = require("settings-ui-sdk/utils/actions");

var PipelineActionTypes = (0, _namespacedKeyMirror.default)({
  GET_PIPELINES: null
}, 'pipelines');
exports.PipelineActionTypes = PipelineActionTypes;
var GetPipelinesActionTypes = (0, _actions.createRequestTypes)(PipelineActionTypes.GET_PIPELINES);
exports.GetPipelinesActionTypes = GetPipelinesActionTypes;
var getPipelines = (0, _fluxActions.createAction)(PipelineActionTypes.GET_PIPELINES);
exports.getPipelines = getPipelines;
var receiveGetPipelines = (0, _actions.createRequestActions)(GetPipelinesActionTypes);
exports.receiveGetPipelines = receiveGetPipelines;